
document.addEventListener('openable-element:open', function(event) {
    if(event.target.classList.contains('help-drawer') && !event.target.classList.contains('loaded-size') ) {
        console.log(event.target.getAttribute('data-variant_id'));
        fetchSizeChart(event.target.getAttribute('data-variant_id'));
        event.target.classList.add('loaded-size');
        // const deliveryInfoElement = document.querySelector('#delivery-information');
        // const deliveryInfo = JSON.parse(deliveryInfoElement.getAttribute('data-delivery-info'));
        //
        // const product_id = deliveryInfoElement.getAttribute('data-product_id');
        // const variant_id = deliveryInfoElement.getAttribute('data-variant_id');
        // fetchSizeChart(variant_id);
    }
});
document.addEventListener('variant:changed', function(event) {
    // if #delivery-information data-vendor if not equal to Wiln
   // if (document.querySelector('#delivery-information').getAttribute('data-vendor') !== 'Wiln') {
        fetchSizeChart(event.detail.variant.id);
        // event.target.closest('.drawer__content').querySelectorAll('.help-drawer').forEach(function (item) {
        //     item.classList.add('loaded-size');
        // });
    //}
});



// Fetch data from your API
async  function fetchSizeChart(variant_id){

    // console.log('https://app.bananashoes.com/size-chart/'+variant_id);
    await fetch('https://app.bananashoes.com/size-chart/'+variant_id, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    })
        .then(response => response.json())
        .then(data => {
            if (data) {
                htmlIframe(data);
                createSizeChartTable(data);
                document.querySelectorAll('.size-chart-wrap').forEach(function(item) {
                    item.style.display = "block";
                });
            } else {
                document.querySelectorAll('.size-chart-wrap').forEach(function(item) {
                    item.style.display = "none";
                });
            }
        })
        .catch(error => console.error('Error:', error));
}

function htmlIframe(data) {
    if (data.html_video) {
        const insertbefore = document.querySelector('.product__media-list-wrapper');
        let modal = document.querySelector('#html_video');
        let icon = document.querySelector('.html_video_button');
        let iframe;

        if (!modal) {
            // Create the modal if it doesn't exist
            modal = document.createElement('div');
            modal.setAttribute('id', 'html_video');
            modal.classList.add('modal');
            modal.innerHTML = `
              <div class="modal__overlay"></div>
              <div class="modal__content">
                <button type="button" class="modal__close-button tap-area" data-action="close" title="close">
                  Close
                </button>
                <div class="newsletter-modal">
                  <div class="newsletter-modal__content text-container text--center">
                    <!-- iframe will be appended here -->
                  </div>
                </div>
              </div>
            `;

            // Append modal to body
            document.body.appendChild(modal);

            // Add close event listeners
            modal.querySelector('.modal__overlay').addEventListener('click', function () {
                modal.removeAttribute('open');
            });
            modal.querySelector('[data-action="close"]').addEventListener('click', function () {
                modal.removeAttribute('open');
            });
        }

        // Check for the iframe inside the modal
        iframe = modal.querySelector('iframe');
        if (!iframe) {
            // Create the iframe if it doesn't exist
            iframe = document.createElement('iframe');
            modal.querySelector('.newsletter-modal__content').appendChild(iframe);
        }

        // Update the iframe's source to the current variant video
        iframe.setAttribute('src', data.html_video);

        if (!icon) {
            // Create the icon if it doesn't exist
            icon = document.createElement('button');
            icon.classList.add('html_video_button');
            insertbefore.insertBefore(icon, insertbefore.firstChild);

            // Add open modal event listener
            icon.addEventListener('click', function () {
                modal.setAttribute('open', true);
            });
        }
    } else{
        //remove icon from page
        let icon = document.querySelector('.html_video_button');
        if (icon) {
            icon.remove();
        }
        //remove modal from page
        let modal = document.querySelector('#html_video');
        if (modal) {
            modal.remove();
        }
    }
}


function createSizeChartTable(data) {

    // Create table element
    let table = document.createElement('table');
    table.classList.add('sizes');

    // Create and append the header
    let thead = document.createElement('thead');
    let headerRow = document.createElement('tr');
    headerRow.innerHTML = `<th>Selected size: ${data.size}</th><th>cm</th><th>in</th>`;
    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create and append the body
    let tbody = document.createElement('tbody');

    // Assuming 'data' is the JSON response similar to the array structure you provided
    for (let sizeName in data.cm) {
        let row = document.createElement('tr');
        let name = sizeName;
        let sizeNameCell = document.createElement('td');
        if (name === 'Shoe Size (foot length)') {
            name = 'Shoe Size (foot length - cm)';
        }
        sizeNameCell.textContent = name;

        // Add tooltip if helper text is available
        if (data.cm[sizeName].helper) {
            let tooltip = document.createElement('span');
            tooltip.classList.add('tooltip-icon');
            tooltip.innerHTML = '<i class="fa-solid fa-circle-question"></i>';
            tooltip.setAttribute('data-tooltip', data.cm[sizeName].helper);
            sizeNameCell.appendChild(tooltip);
        }

        let cmValueCell = document.createElement('td');
        cmValueCell.textContent = data.cm[sizeName].value;
        console.log(sizeName);

        let inValueCell = document.createElement('td');
        inValueCell.textContent = data.in[sizeName] ? data.in[sizeName].value : '';

        row.appendChild(sizeNameCell);
        row.appendChild(cmValueCell);
        row.appendChild(inValueCell);

        tbody.appendChild(row);
    }

    table.appendChild(tbody);

    // Append the table to the container

    document.querySelectorAll('.sizes tr.selected').forEach(function(item) {
        item.classList.remove('selected');
    });
    document.querySelectorAll('.sizes td[data-label="UK"]').forEach(function(item) {

        let size_num = data.size.replace('UK ', '');
        if (parseInt(size_num) === parseInt(item.textContent)) {
            item.closest('tr').classList.add('selected');
        }
    });
    document.querySelectorAll('.sizeChartContainer').forEach(function(item) {
        item.innerHTML = table.outerHTML;

        // Append the selected size div first

        // Then append the table
    })

}


